import React, { useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { useHistory } from "react-router-dom";
import { notificationService } from "../../../service/NotificationService";
import EditButton from "components/Buttons/EditButton";
import CreateButton from "components/Buttons/CreateButton";

import { useTranslation } from "react-i18next";

function AttributePage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/attributes";
  const history = useHistory();
  const { id } = useParams();

  // Fields
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [credits, setCredits] = useState(0);
  const [reusable, setReusable] = useState(false);

  const [version, setVersion] = useState(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const save = () => {
    setIsDisabled(true);
    const attribute = {
      name: name ? name : undefined,
      description: description ? description : undefined,
      credits: credits,
      reusable: reusable,
      version: version != null ? version + 1 : undefined,
    };
    if (id) {
      apiService
        .putJson(`api/v1/attributes/${id}`, attribute)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.featureSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/attributes", attribute)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.featureCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  React.useEffect(() => {
    if (id) {
      apiService
        .get(`api/v1/attributes/${id}`)
        .then((attribute) => {
          fillFields(attribute);
        })
        .catch((error) => {
          notificationService.notifyError(error.message);
          history.push(backRoute);
        });
    }
  }, []);

  const fillFields = (attribute) => {
    if (attribute.name) {
      setName(attribute.name);
    }

    if (attribute.description) {
      setDescription(attribute.description);
    }

    if (attribute.credits) {
      setCredits(attribute.credits);
    } else {
      setCredits(0);
    }

    setReusable(attribute.reusable);

    setVersion(attribute.version);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="6">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editFeature") : t("pages.titles.createFeature")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Form.Group>
                    <label>{t("common.labels.designation")}</label>
                    <Form.Control
                      placeholder={t("common.labels.designation")}
                      required={true}
                      type="text"
                      value={name}
                      onChange={(event) => setName(event.target.value)}
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group>
                    <label>{t("common.labels.description")}</label>
                    <Form.Control
                      placeholder={t("common.labels.description")}
                      as="textarea"
                      rows={3}
                      type="text"
                      value={description}
                      onChange={(event) => {
                        if (event.target.value.length <= 255) {
                          setDescription(event.target.value);
                        }
                      }}
                    ></Form.Control>
                    <Form.Text className="text-muted">{t("common.labels.value")}{255 - description.length}{t("common.labels.charactersRemainingPrefix")}</Form.Text>
                  </Form.Group>
                  <Form.Group>
                    <label>{t("common.labels.cost")}</label>
                    <Form.Control
                      placeholder={t("common.labels.cost")}
                      type="number"
                      value={credits}
                      min={0}
                      onChange={(event) => setCredits(event.target.value)}
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group>
                    <Form.Check>
                      <Form.Check.Label>
                        <Form.Check.Input
                          checked={reusable}
                          onChange={(event) => setReusable(event.target.checked)}
                          type="checkbox"
                        ></Form.Check.Input>
                        <span className="form-check-sign"></span>{t("common.labels.multipleChoice")}</Form.Check.Label>
                    </Form.Check>
                  </Form.Group>
                </Form>
                {id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AttributePage;
